import _ from 'lodash';
import { IGlobalState } from "../states/GlobalState";
import { elaboraConvSrl, elaboraIForfetari, elaboraSchedaBudget } from "../services/api";
import auth, { IAuth, AuthDataType, clearIdentityFromStorage } from "../types/auth";
import { User } from 'oidc-client';
import { isValidUser } from '../services/validityService';

export function findElement(arr, propName, propValue) {
  for (var i = 0; i < arr.length; i++)
    if (arr[i][propName] === propValue)
      return arr[i];

  // will return undefined if not found; you could return a default instead
}

export function findElementByKey(arr, propValue) {
  for (var i = 0; i < arr.length; i++)
    if (arr[i]["key"] === propValue)
      return arr[i];

  // will return undefined if not found; you could return a default instead
}

export function roundTo(n, digits, roundUpDown = false) {
  //se roundUpDown è undefined allora il roundTo si comporta come prima, se no arrotonda al intero, come descritto sotto nel else
  if (roundUpDown === false) {
    var negative = false;
    if (digits === undefined) {
      digits = 0;
    }
    if (n < 0) {
      negative = true;
      n = n * -1;
    }
    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    // n = (Math.round(n) / multiplicator).toFixed(digits);
    n = Math.round(n) / multiplicator;
    if (negative) {
      n = (n * -1).toFixed(digits);
    }
  }
  else {
    //la Math.round si comporta cosi:
    //1.5 diventa 2
    //1.49 diventa 1
    //1.51 diventa 2
    n = Math.round(n);
  }
  return n;
}

export function GestParseFloatNaN(n: number) {
  if (n) {
    let y = parseFloat(n.toString());
    if (isNaN(y))
      return 0;
    else
      return y;
  }
  else
    return 0;
}

export function calcolaRedditivita(value: any) {
  if (value === "Industrie alimentari e delle bevande" ||
      value === "Commercio all'ingrosso e al dettaglio" ||
      value === "Commercio ambulante alimentari e bevande" ||
      value === "Attività dei Servizi di alloggio e di ristorazione" ||
      value === "Commercio ambulante alimentari e bevande") {
      return 40;
  }
  else if (value === "Commercio ambulante di altri prodotti") {
      return 54;
  }
  else if (value === "Costruzioni e attività immobiliari") {
      return 86;
  }
  else if (value === "Intermediari del commercio") {
      return 62;
  }
  else if (value === "Attività Professionali, Scientifiche, ecc.") {
      return 78;
  }
  else if (value === "Altre attività economiche") {
      return 67;
  }
  else {
      return 0;
  }
}

function getStateFromAction(action: string) {
  switch (action) {
    case "changeContributiImposta":
      return "redditoContributiImposta";
    case "changeRegimeForfettario":
      return "regimeForfettario";
    case "changeInformazioniIniziali":
      return "";
    case "changeGestionePrevidenziale":
      return "gestionePrevidenziale";
    case "changeRegimeNormale":
      return "regimeNormale";
    case "changeLiquidazioneIrpef":
      return "liquidazioneIrpef";
    case "changeDatiCollaboratore1":
      return "datiCollaboratore1";
    case "changeDatiCollaboratore2":
      return "datiCollaboratore2";
    case "changeConfronto":
      return "confronto";
    case "changeDatiSimulazioniSrl":
      return "datiSimulazioniSrl";
    case "changeInformazioniCostiBudget":
      return "informazioniCostiDiAvvio";
    case "changeIscrizioneRegistroImprese":
      return "iscrizioneRegistroImprese";
    case "changeIscrizioneImpreseArtigiane":
      return "iscrizioneImpreseArtigiane";
    case "changeContoEconomicoProfessionista":
      return "contoEconomicoProfessionista";
    case "changeContoEconomicoDittaSocieta":
      return "contoEconomicoDittaSocieta";
    case "changeInail":
      return "inail";
    case "changeCCIAA":
      return "dirittiCCIAA";
    case "changeImposteContributi":
      return "imposteContributi";
    case "changeForfetari":
      return "forfetari";
    case "changeGruppoDiSettore":
      return "forfetari";
    default:
      throw new Error();
  }
}

function getState(props: any, name: string, value: any, action: string, useLocalState: boolean) {
  let state = props.state;
  if (useLocalState) {
    let sezioneStato = getStateFromAction(action);
    if (sezioneStato !== "") {
      state = {
        ...props.state,
        [sezioneStato]: {
          ...props.state[sezioneStato],
          [name]: value
        }
      };
    }
    else {
      state = {
        ...props.state,
        [name]: value
      }
    };
  }

  return state;
}

export function API_elaboraSchedaBudget(props: any, global: IGlobalState, name: string = "", value: any = null, action: string = "", useLocalState: boolean = false) {
  // let state = props.state;
  // if (useLocalState) {
  //   state = getState(props, name, value, action, useLocalState)
  // }

  // props.handleChange("setLoading", "", true);
  // _.debounce(() => {
  //   elaboraSchedaBudget(auth.getUsername(global), JSON.stringify(state), global).then(elab => {
  //     props.handleChange("count", "", elab.State);
  //   });
  //   },
  // 10,
  // { 'maxWait': 10 })();
}

export function API_elaboraSchedaBudgetGlobal(props: any, global: IGlobalState, name: string = "", value: any = null, action: string = "", useLocalState: boolean = false) {
  let state = props.state;
  if (useLocalState) {
    state = getState(props, name, value, action, useLocalState)
  }

  props.handleChange("setLoading", "", true);
  _.debounce(() => {
    elaboraSchedaBudget(props.username, JSON.stringify(state), global).then(elab => {
      props.handleChange("count", "", elab.State);
    });
    },
  10,
  { 'maxWait': 10 })();
}

export function API_elaboraIForfetari(props: any, global: IGlobalState, name: string = "", value: any = null, action: string = "", useLocalState: boolean = false) {
  // let state = props.state;
  // if (useLocalState) {
  //   state = getState(props, name, value, action, useLocalState)
  // }

  // props.handleChange("setLoading", "", true);
  // _.debounce(() => {
  //   elaboraIForfetari(props.username, JSON.stringify(state), global).then(elab => {
  //     props.handleChange("count", "", elab.State);
  //   });
  //   },
  // 10,
  // { 'maxWait': 10 })();
}

export function API_elaboraIForfetariGlobal(props: any, global: IGlobalState, name: string = "", value: any = null, action: string = "", useLocalState: boolean = false) {
  let state = props.state;
  if (useLocalState) {
    state = getState(props, name, value, action, useLocalState)
  }

  props.handleChange("setLoading", "", true);
  _.debounce(() => {
    elaboraIForfetari(props.username, JSON.stringify(state), global).then(elab => {
      props.handleChange("count", "", elab.State);
    });
    },
  10,
  { 'maxWait': 10 })();
}

export function API_elaboraConvSrl(props: any, global: IGlobalState, name: string = "", value: any = null, action: string = "", useLocalState: boolean = false) {
  // let state = props.state;
  // if (useLocalState) {
  //   state = getState(props, name, value, action, useLocalState)
  // }

  // props.handleChange("setLoading", "", true);
  // _.debounce(() => {
  //   elaboraConvSrl(props.username, JSON.stringify(state), global).then(elab => {
  //     props.handleChange("count", "", elab.State);
  //   });
  //   },
  // 10,
  // { 'maxWait': 10 })();
}

export function API_elaboraConvSrlGlobal(props: any, global: IGlobalState, name: string = "", value: any = null, action: string = "", useLocalState: boolean = false) {
  let state = props.state;
  if (useLocalState) {
    state = getState(props, name, value, action, useLocalState)
  }

  props.handleChange("setLoading", "", true);
  _.debounce(() => {
    elaboraConvSrl(props.username, JSON.stringify(state), global).then(elab => {
      props.handleChange("count", "", elab.State);
    });
    },
  10,
  { 'maxWait': 10 })();
}

// Not used, not necessary
export const verifyUser = async (ip: string, auth: IAuth, user: User, username: string) => {

  let isValid: boolean = await isValidUser(ip, auth.authData!, user, username);
  console.log('Ritorno isValidUser uguale a : ' + isValid);
  if (isValid === false) {
    clearIdentityFromStorage();
    auth.userManager.signoutRedirect();  
  }

}
